import ChevronDownIcon from 'assets/icons/chevron-down-3.svg';
import { MasterSubCategory } from 'domain/entities/MasterEntity';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import { useEffect, useState } from 'react';
import { useCollapse } from 'react-collapsed';
import { useNavigate, useParams } from 'react-router-dom';
import { ListedPropertyRoomGetAssessmentDetail } from '../../CU-033-01/models/Property';
import { generateAssessmentDetail } from '../helper';
import { AssessmentDetailType } from '../models/DetailProperty';
import { DetailRow } from './DetailRow';

interface props {
    data?: ListedPropertyRoomGetAssessmentDetail;
    options: {
        toiletBath: MasterSubCategory[];
        laundryArea: MasterSubCategory[];
        status: MasterSubCategory[];
        roomLayoutDiv: MasterSubCategory[];
    };
}

export const AssessmentDetail = ({ data, options }: props) => {
    const navigate = useNavigate();
    const { getCollapseProps, getToggleProps, isExpanded } = useCollapse();
    const [state, setState] = useState<AssessmentDetailType[]>([]);
    const { propertyId, registeredId } = useParams();

    useEffect(() => {
        setState(generateAssessmentDetail(options, data));
    }, [JSON.stringify(data), JSON.stringify(options)]);

    return (
        <section
            style={{
                width: '100%',
            }}
        >
            <div {...getToggleProps()}>
                <section className="button-style" style={{ marginBottom: 24 }}>
                    <section
                        style={{
                            height: 24,
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                        }}
                    >
                        <div className="collapse-big-title ">これまでの入力項目</div>
                        <div className="button-style center-inside" style={{ marginLeft: 8 }}>
                            <img
                                alt=""
                                src={ChevronDownIcon}
                                className={`collapse-icon ${
                                    isExpanded ? 'collapse-icon-active' : ''
                                }`}
                            />
                        </div>
                    </section>
                    <section className="collapse-small-title" style={{ marginTop: 12 }}>
                        修正点があれば、以下より修正してください。
                    </section>
                </section>
            </div>
            <div {...getCollapseProps()}>
                <section
                    className="content"
                    style={{
                        width: '100%',
                        height: 'fit-content',
                    }}
                >
                    {state.map((element, index) => (
                        <DetailRow
                            key={index}
                            value={element.value}
                            name={element.name}
                            onClick={() => {
                                navigate(
                                    `${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_031_01}/${propertyId}/${registeredId}/${element.step}/${element.field}`,
                                );
                            }}
                        />
                    ))}
                </section>
            </div>
        </section>
    );
};
